// extracted by mini-css-extract-plugin
export default {"root":"classes_root__ad2IP","icon":"classes_icon__q5zja"};